const Cookie = {
    set: (name, value, expires) => {
        let d = new Date()
        d.setTime(d.getTime() + expires)
        window.document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`
    },
    get: (name) => {
        const v = window.document.cookie.match(`(^|;)?${name}=([^;]*)(,|$)?`)
        return v ? v[2] : null
    },
    delete: function (name) {
        this.set(name, '', -1)
    },
    clear: function(name) {
        Cookie.set(name, '', -1)
    }
}

export default Cookie
